import DoubleHeading from "components/DoubleHeading"
import DynamicComponent from ".."

export default function GenericSection({ blok }) {
  return (
    <section className="mx-6 py-16 lg:py-24">
      <div className="max-w-screen-lg mx-auto">
        <div className="max-w-2xl pb-12 relative z-10 text-center mx-auto">
          {blok.eyebrow && <span className="eyebrow eyebrow-2">{blok.eyebrow}</span>}
          <DoubleHeading className="px-12 lg:container mb-1" heading={blok.heading} heading2={blok.heading2} />
        </div>
        <div>
          {blok.blocks &&
            blok.blocks.map((blok) => {
              return <DynamicComponent blok={blok} key={blok._uid} />
            })}
        </div>
      </div>
    </section>
  )
}
